var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"horizontal"},_vm._l((_vm.source.data),function(item){return _c('div',{key:item[_vm.dataKey]},[_c(_vm.component,{tag:"div",attrs:{"source":item,"extra-props":_vm.extraProps}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }